<template>
  <fragment>
    <template v-for="item in routes">
      <el-menu-item
        v-if="!item.children && !isNest"
        :to="item.path"
        :key="item.name"
        :index="item.path"
      >
        <svg-icon :icon-class="item.meta.icon" class-name="icon"></svg-icon>
        <span
          slot="title"
          v-if="item.meta && item.meta.title"
          class="iconTitle"
          >{{ item.meta.title }}</span
        >
      </el-menu-item>
      <el-submenu v-else :index="item.path" :key="item.name">
        <template slot="title">
          <svg-icon :icon-class="item.meta.icon" class-name="icon"></svg-icon>
          <span
            slot="title"
            v-if="item.meta && item.meta.title"
            class="iconTitle"
            >{{ item.meta.title }}</span
          >
        </template>
        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item
            :isNest="true"
            class="nest-menu"
            v-if="child.children && child.children.length > 0"
            :routes="[child]"
            :key="child.path"
          ></sidebar-item>
          <el-menu-item
            v-else
            :to="child.path"
            :key="child.name"
            :index="child.path"
          >
            <svg-icon
              :icon-class="child.meta.icon"
              class-name="icon"
            ></svg-icon>
            <span
              slot="title"
              v-if="child.meta && child.meta.title"
              class="iconTitle"
              >{{ child.meta.title }}</span
            >
          </el-menu-item>
        </template>
      </el-submenu>
    </template>
  </fragment>
</template>

<script>
/**
 * 递归菜单项组件
 * 功能：支持多级菜单（el-submenu）与叶子菜单（el-menu-item）
 */
export default {
  name: 'sidebarItem',
  props: {
    routes: {
      type: Array,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ok(value) {
    },
  },
}
</script>
<style></style>
